import { Cluster } from "./Cluster";
import { getFranchiseWebLocations } from "./getFranchiseWebLocations";
import { renderMap } from "./renderMap";
import { reportScreenSize } from "./reportScreenSize";
import { ResultsList } from "./ResultsList";
import { ScreenType } from "./models/ScreenType";
import { Search } from "./Search";
import { startLoader, stopLoader } from "../util/loader";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { getBrandDetailsFromBrandJson, isISNFlow } from "../util/share";
import { getLocalization, getPageInfo } from "../util/add-Page-Type-DataLayer";

export class App {
    webLocations: any;
    map!: H.Map;
    ui!: H.ui.UI;
    cluster!: Cluster;
    resultsList!: ResultsList;
    search!: Search;
    screenType!: ScreenType;
    // fullAttributeContainer: FullAttributeContainer;

    constructor(webLocations: any, isMapWrapper: boolean = true) {
        this.handleAreaWeServeSearch();
        if(!isMapWrapper){
            return;
        }
        this.webLocations = webLocations;
        this.loadData();
        this.windowResizeCallback();
    }
    static async create() {
        const mapWrapper = document.querySelectorAll('.map-wrapper,.map-wrapper-mobile');
        if (mapWrapper.length > 0) {
            const webLocations = await getFranchiseWebLocations();
            return new App(webLocations);
        }else{
            return new App([], false);
        }
    }
    public handleAreaWeServeSearch() {
        try {
            this.preventAreaWeServeFormSubmit();
            const newAreaWeServe = document.querySelector('.find-location-section.area-we-serve');
            if (!newAreaWeServe) return;

            const newAreaWeServeCta = newAreaWeServe.querySelector<HTMLButtonElement>('.areaserve-form-cta button');
            if (!newAreaWeServeCta) return;

            newAreaWeServeCta.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.handleAreaWeServeSearchSubmit();
            });

            this.addClickEventListenerToOSCta();
        } catch (error) {
            // Log error for debugging, but do not break the app
            console.error("An error occurred in handleAreaWeServeSearch: ", error);
        }
    }

    public handleAreaWeServeSearchSubmit() {
        const showAllLocations = (locationLists: NodeListOf<HTMLLIElement>) => {
            for (const li of locationLists) {
                li.style.display = 'flex';
                const locationDataNodes = li.querySelectorAll<HTMLDivElement>('.location-data');
                for (const locationData of locationDataNodes) {
                    locationData.style.display = '';
                }
            }
        };

        const filterLocations = (
            locationLists: NodeListOf<HTMLLIElement>,
            searchValue: string
        ): boolean => {
            let isNoMatchFound = true;
            for (const li of locationLists) {
                const headingText = li.querySelector('.location-list-heading')?.textContent?.trim().toLowerCase() ?? '';
                const locationDataDivs = li.querySelectorAll<HTMLDivElement>('.location-data');
                if (headingText.includes(searchValue)) {
                    li.style.display = 'flex';
                    for (const locationData of locationDataDivs) {
                        locationData.style.display = '';
                    }
                    isNoMatchFound = false;
                    continue;
                }
                let anyLocationDataMatched = false;
                for (const locationData of locationDataDivs) {
                    const textToSearch = locationData.innerText?.toLowerCase() ?? '';
                    if (textToSearch.includes(searchValue)) {
                        locationData.style.display = '';
                        anyLocationDataMatched = true;
                        isNoMatchFound = false;
                    } else {
                        locationData.style.display = 'none';
                    }
                }
                li.style.display = anyLocationDataMatched ? 'flex' : 'none';
            }
            return isNoMatchFound;
        };
        const areaServeSearch = document.getElementById('area-serve-search') as HTMLInputElement | null;
        const locationLists = document.querySelectorAll<HTMLLIElement>('#accordion-locations li.card-list');
        if (!areaServeSearch || locationLists.length === 0) return;

        const searchValue = areaServeSearch.value.trim().toLowerCase();
        let isNoMatchFound: boolean;

        if (searchValue) {
            isNoMatchFound = filterLocations(locationLists, searchValue);
        } else {
            showAllLocations(locationLists);
            isNoMatchFound = false;
        }

        const noMatchElement = document.getElementById('area-no-results');
        if (noMatchElement) {
            noMatchElement.style.display = isNoMatchFound ? 'flex' : 'none';
        }
    }

    public preventAreaWeServeFormSubmit() {
        const areaWeServeForm = document.querySelector('.find-location-section.area-we-serve .location-search-form');
        if (!areaWeServeForm) return;
        areaWeServeForm.addEventListener('submit', (event) => {
                event.preventDefault();
                this.handleAreaWeServeSearchSubmit();
            });
    }
    
    addClickEventListenerToOSCta() {
        const conceptCode = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        if (conceptCode.toLocaleLowerCase() !== "25") {
            return;
        }
        const osCta = document.querySelectorAll('.area-serve-location-cta a');
        if (osCta.length > 0) {
            for (const element of osCta) {
                element.addEventListener('click', (e) => {
                    e.preventDefault();
                    const locationItem = (e.currentTarget as HTMLElement).closest(".location-data");
                    if (locationItem) {
                        const locationText = (locationItem.querySelector(".area-location-zipcode") as HTMLInputElement)?.value?.trim() ?? "";
                        const franchiseWebLocationId = (locationItem.querySelector(".area-location-weblocationid") as HTMLInputElement)?.value?.trim() ?? "";
                        const franchiseId = (locationItem.querySelector(".area-location-weblocationid") as HTMLInputElement)?.value?.trim() ?? "";
                        const franchiseWebLocationMarketingId = (locationItem.querySelector(".area-location-franchiseweblocationmarketingid") as HTMLInputElement)?.value?.trim() ?? "";
                        const zipRegex = /\b(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d)\b/;
                        const zipMatch = zipRegex.exec(locationText);
                        if (zipMatch) {
                            const zipcode = zipMatch[0];
                            sessionStorage.setItem('sAddressParam', zipcode);
                            sessionStorage.setItem('locationLeadFlow', 'true');
                            isISNFlow({franchiseWebLocationId,franchiseId,franchiseWebLocationMarketingId},zipcode,(e.currentTarget as HTMLAnchorElement)?.href);
                        } else {
                            console.log("ZIP code not found in location text.");
                            window.open((e.currentTarget as HTMLAnchorElement).href, '_blank');
                        }
                    } else {
                        console.log('location-item container not found');
                        window.open((e.currentTarget as HTMLAnchorElement).href, '_blank');
                    }

                });
            }
        }
    }
    private loadData() {
        this.loadMapAndResultsList();
        let locationList = document.querySelector(".location-list") as HTMLUListElement;
        if (locationList) {
            locationList.style.display = "block";
        }
    }
    loadMapAndResultsList() {
        // window.addEventListener('load', ()=> {
        this.loadMapAndCluster();
        window.dispatchEvent(new Event('resize')); // Trigger resize

        const mapUi = { map: this.map, ui: this.ui };
        
        // instantiate ResultsList
        this.resultsList = new ResultsList(mapUi, this.webLocations);

        const locationData = sessionStorage.getItem("nearbyLocations");
        let searchValue:any ='';
        if(locationData){
            const obj = JSON.parse(locationData);
            if(obj.containingData){
                searchValue = obj.resultData[0].doingBusinessAs;
            }
            else{
                searchValue = "";
            }
        }
        else{
            const locationInput = document.querySelector('.location-search-input') as HTMLInputElement;
            if(locationInput){
                searchValue = locationInput.value;
            }
        }
        // instantiate Search functionality
        this.search = new Search(mapUi.map, this.resultsList);

        // Search for the location for New Map component
        if(document.querySelector('.map-component')){
            searchValue = (document.getElementById('fetchCity') as HTMLInputElement)?.value ?? '';
            this.search.search(searchValue,false);
            return
        }
        this.search.search(searchValue,false);
        // });

    }
    async loadMapAndCluster() {
        this.screenType = reportScreenSize();
        const mapUi = renderMap(this.screenType);
        this.map = mapUi.map;
        this.ui = mapUi.ui;

        this.cluster = new Cluster(mapUi.map, mapUi.ui);
        this.cluster.startClustering(this.webLocations);
    }
    windowResizeCallback() {
        let newScreenType = reportScreenSize();
        if (this.screenType === ScreenType.Desktop) {
            if (this.screenType === newScreenType) {
                this.map.getViewPort().resize();
            }
        }
    }

}
(async () => {
    document.addEventListener('DOMContentLoaded', async() => {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        await getBrandDetailsFromBrandJson(conceptCode)
        try {
            const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;
            if (pageType && pageType.toLocaleLowerCase() == "opus 2 lead flow confirmation page") {
                const franchiseWebLocationId = sessionStorage.getItem("RL_Weblocation_ID");
                const doingBusinessAs = sessionStorage.getItem("RL_DBAName");
                const leadObj = {
                    event: 'custEv_LocalDataLayer',
                    locationID: franchiseWebLocationId,
                    locationDBA: doingBusinessAs
                }
                if (franchiseWebLocationId && doingBusinessAs)
                    gtmCustomEventLeadFlow(leadObj);
            }
        } catch (error) {
            console.log("An error occurred in gtmCustomEventLeadFlow: ", error);
        }
        try{
     
            const pageType = getPageInfo()
            const pageLocalization = getLocalization();
                let pageData = {
                    event: 'pageDataLayer',
                    pageType,
                    localization: pageLocalization
                    }
                    gtmCustomEventLeadFlow(pageData)
    
        }catch(error){
            console.log("An error occurred in adding PagetypeDatalayer: ", error);
        }
        
        const container = document.querySelector('.find-location-section');
    
        if (container) {
            startLoader();
            const app = await App.create();
            window.addEventListener('resize', () => {
                app.windowResizeCallback();
            });
            stopLoader();
        }
    
    });
})();
